import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useConfig } from "../hooks";
import { PageLoading } from "../shared";

/**
 * Client-side feature guard.
 *
 * - Reads resolved tenant feature flags from `configs.featureFlags`.
 * - Defaults to allow if flag is missing (backwards compatible).
 */
const RequireFeature = ({ featureKey, children, fallbackPath = "/" }) => {
  const location = useLocation();
  const { configs, loading } = useConfig();

  if (loading) {
    return <PageLoading />;
  }

  const value = configs?.featureFlags?.[featureKey];
  const enabled = value === undefined ? true : Boolean(value);

  if (!enabled) {
    return <Navigate to={fallbackPath} replace state={{ from: location }} />;
  }

  return children;
};

export default RequireFeature;

